import { staticText } from '../../../utils/translations/staticText';

export default staticText({
  chooseSsReward: {
    _: '1. Choose Your Money101 Reward',
  },
  brand_reward_guidance: {
    _: "Money101's reward",
    zh: 'Money101 獨家獎勵',
  },
});
